export default "__VITE_ASSET__CD1$GmVU__"